import React from 'react';
// Ez az oldal egyelőre csak egy placeholder, a moderálás a BooksPage-en belül történik.
// Később itt lehetne egy központi moderációs felület.
const FeedbacksPage = () => {
    return (
        <div>
            <h1>Visszajelzések</h1>
            <p>A visszajelzések moderálása a "Könyvek Kezelése" menüponton belül, az egyes könyveknél lehetséges.</p>
        </div>
    );
};
export default FeedbacksPage;